import React, { FC } from 'react'

import SvgWarning from '@Assets/SVG/Warning'
import { useTranslation } from '@Globals/Translations'

import styles from './PaymentError.module.scss'

interface PaymentErrorProps {
  closeModal: () => void
  error?: string
  introText?: string
}
export const PaymentError: FC<PaymentErrorProps> = ({ closeModal, error, introText }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.paymentErrorWrapper}>
      <SvgWarning />
      <p className={styles.introText}>{introText || t('checkout:COF_PAYMENT_FAILED_INTRO_TEXT')}</p>
      {error && <p>{error}</p>}
      <button onClick={() => closeModal()} type="button">{t('common:OKAY')}</button>
    </div>
  )
}
